export enum PaymentPartyEnum {
  Organization = 'Organization Pays',
  Member = 'Member Pays',
}

export enum PaidByEnum {
  Org = 'ORG',
  User = 'USER',
}

export interface LicenseData {
  cost: number;
  quantity?: number;
  paymentParty: string;
  package?: string;
  licensesPurchased?: number;
  activeUsers?: number;
}
